import {useFormik} from "formik";
import * as Yup from "yup";
import React, {useState} from "react";
import {FaUser} from "react-icons/fa";
import {RadioGroup} from "../RadioGroup";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";

const UserInformationForm = props => {
    const {onConfirm, processInfo} = props;
    const [isOwner, setIsOwner] = useState((processInfo?.im_owner === null && processInfo?.i_have_access_to_owner === null) ? true : processInfo?.im_owner)
    const [accessToOwner, setAccessToOwner] = useState(!!processInfo?.i_have_access_to_owner)
    const userValidation = Yup.object().shape({
        nid: Yup.string().required('فیلد کد ملی الزامیست.').min(10, 'فیلد کد ملی یا شناسه ملی حداقل ۱۰ رقم می باشد.').max(11, 'فیلد کد ملی یا شناسه ملی حداکثر ۱۰ رقم می باشد.'),
        ownerMobile: accessToOwner ? Yup.string().matches(/^(09|۰۹)[0-9۰-۹]{9}$/, 'شماره موبایل نامعتبر می‌باشد.').required('شماره موبایل الزامیست.') : null

    });
    const handleUserInfo = (values) => {
        const data = {
            im_owner: isOwner,
            i_have_access_to_owner: accessToOwner,
            nid: values.nid,
            mobile: accessToOwner ? values.ownerMobile : null,
        }
        onConfirm(data);
    }
    const handleAccessToOwner = (value) => {
        if (value === "im_owner") {
            setIsOwner(true);
            setAccessToOwner(false);
            userFormik.setFieldValue("ownerMobile",processInfo.platform_user);

        } else {
            setIsOwner(false);
            setAccessToOwner(true);
            userFormik.setFieldValue("ownerMobile",'');
        }

    }
    const userFormik = useFormik({
        initialValues: {
            nid: processInfo?.confirmed_data?.NationalId || '',
            ownerMobile: accessToOwner ? processInfo?.confirmed_data?.Mobile : processInfo.platform_user
        },
        validationSchema: userValidation,
        onSubmit: handleUserInfo
    });
    return <form onSubmit={userFormik.handleSubmit} className="w-full rounded-xl bg-white max-w-md p-5 justify-self-center flex flex-col gap-3">
        <div className=" border-b w-full flex flex-col justify-center items-center  pb-3">
            <div className=" p-3 border-2 border-green-300 rounded-full bg-green-500 bg-opacity-20">
                <FaUser className="text-green-500 text-3xl "/>
            </div>
            <h1 className="mt-3 text-sm font-bold ">اطلاعات صاحب ملک را وارد کنید.</h1>
        </div>
        <div className="w-full flex mt-4 flex-col">
            <label className="text-sm" htmlFor="nid">کد ملی مالک </label>
            <input dir="ltr" onChange={userFormik.handleChange} value={userFormik.values.nid} type="tel"
                   className="w-full bg-gray-100  text-sm text-right mt-1 rounded-lg p-3"
                   placeholder="کد ملی مالک  را وارد کنید"
                   name="nid"/>
            {userFormik.errors.nid && userFormik.touched.nid ? (
                <p className="text-red-400 text-sm font-light  ">{userFormik.errors.nid}</p>
            ) : null}
            <div className="grid grid-cols-1 w-full  mt-3 ">
                <p className="text-sm mb-1 ">وضعیت مالکیت ملک</p>
                <RadioGroup selectedIndex={isOwner ? 0 : 1}
                            handleChange={handleAccessToOwner}
                            items={[
                                {
                                    value: "im_owner",
                                    text: "مالک هستم"
                                },
                                {
                                    value: "i_have_access_to_owner",
                                    text: "به مالک دسترسی دارم"
                                }
                            ]}/>

                <div className=" py-3 ">
                    <label className="text-sm" htmlFor="ownerMobile">موبایل مالک </label>
                    <input disabled={isOwner} dir="ltr" onChange={userFormik.handleChange} value={userFormik.values.ownerMobile}
                           type="tel"
                           className={`w-full bg-gray-100 text-sm text-right mt-1 rounded-lg p-3 ${isOwner ? 'bg-gray-200 cursor-not-allowed':'bg-gray-100'}`}
                           placeholder="موبایل مالک را وارد کنید"
                           name="ownerMobile"/>
                    {userFormik.errors.ownerMobile && userFormik.touched.ownerMobile ? (
                        <p className="text-red-400 text-sm font-light  ">{userFormik.errors.ownerMobile}</p>
                    ) : null}
                </div>
            </div>
        </div>
        <div className="border-t  pt-5">
            <Button type="submit" rounded="rounded-lg" className="w-full   flex justify-center items-center"
                    theme="green"><span>مرحله بعد</span></Button>
        </div>
    </form>
}
export default UserInformationForm;